import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['ReviewsImages'] });

const apiReviewsImagesSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getReviewImages: builder.query({
      query: ({ ean, rpk }) => {
        return {
          url: `/community/products/${ean}/reviews/${rpk}/images/`,
        };
      },
      providesTags: ['ReviewsImages'],
    }),
    getReviewImagesDetail: builder.query({
      query: ({ ean, rpk, ipk }) => {
        return {
          url: `/community/products/${ean}/reviews/${rpk}/images/${ipk}`,
        };
      },
      providesTags: ['ReviewsImages'],
    }),
    addNewReviewImage: builder.mutation({
      query: ({ ean, rpk, image }) => ({
        url: `/community/products/${ean}/reviews/${rpk}/images/`,
        method: 'POST',
        body: image,
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ReviewsImages'],
    }),
    updateReviewImage: builder.mutation({
      query: ({ image, ean, rpk, ipk }) => ({
        url: `/community/products/${ean}/reviews/${rpk}/images/${ipk}`,
        method: 'PUT',
        body: image,
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ReviewsImages'],
    }),
    deleteReviewImage: builder.mutation({
      query: ({ ean, rpk, ipk }) => ({
        url: `/community/products/${ean}/reviews/${rpk}/images/${ipk}`,
        method: 'DELETE',
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ReviewsImages'],
    }),
  }),
});

export const { useGetReviewImagesQuery, useGetReviewImagesDetailQuery, useAddNewReviewImageMutation, useUpdateReviewImageMutation, useDeleteReviewImageMutation } = apiReviewsImagesSlice;

export default apiReviewsImagesSlice;
